import {
  fieldConfig,
  CustomerForm,
  CustomerSelectOption,
  CustomerActivity,
  CustomerPriceQuote,
  CustomerPriceQuoteStatus,
  CustomerWorkOrder,
  Financial,
  CustomerDocument,
  contactForm,
} from "./types";

export const MOCK_CUSTOMER_PRICE_QUOTES: CustomerPriceQuote[] = [
  {
    id: "1",
    quoteNumber: "PQ-3301",
    createdAt: "2026-06-01",
    projectTypeKey: "CUSTOMERS.DETAILS.MOCK.PRICE_QUOTES.REFRIGERATED_TRAILER",
    revisionNumber: 1,
    totalValue: 185000,
    status: CustomerPriceQuoteStatus.ACCEPTED,
    validUntil: "2026-07-01",
  },
  {
    id: "2",
    quoteNumber: "PQ-3302",
    createdAt: "2026-06-12",
    projectTypeKey: "CUSTOMERS.DETAILS.MOCK.PRICE_QUOTES.HEAVY_TIPPER",
    revisionNumber: 2,
    totalValue: 92000,
    status: CustomerPriceQuoteStatus.SENT,
    validUntil: "2026-07-12",
  },
  {
    id: "3",
    quoteNumber: "PQ-3303",
    createdAt: "2026-06-28",
    projectTypeKey: "CUSTOMERS.DETAILS.MOCK.PRICE_QUOTES.CUSTOM_OPEN_BODY",
    revisionNumber: 1,
    totalValue: 43000,
    status: CustomerPriceQuoteStatus.DRAFT,
    validUntil: "2026-07-28",
  },
];

export const MOCK_CUSTOMER_WORK_ORDERS: CustomerWorkOrder[] = [
  {
    id: 1,
    workOrderId: "WO-5501",
    status: "IN_PRODUCTION",
    vehicleKey: "CUSTOMERS.DETAILS.MOCK.WORK_ORDERS.REFRIGERATED_TRAILER",
    currentStage: "PAINT",
    progress: 65,
    priority: "HIGH",
  },
  {
    id: 2,
    workOrderId: "WO-5502",
    status: "IN_PRODUCTION",
    vehicleKey: "CUSTOMERS.DETAILS.MOCK.WORK_ORDERS.HEAVY_TIPPER",
    currentStage: "METALWORK",
    progress: 15,
    priority: "NORMAL",
  },
  {
    id: 3,
    workOrderId: "WO-5503",
    status: "IN_PRODUCTION",
    vehicleKey: "CUSTOMERS.DETAILS.MOCK.WORK_ORDERS.CLOSED_BOX_REPAIR",
    currentStage: "QUALITY_CONTROL_STAGE",
    progress: 90,
    priority: "MEDIUM",
  },
];

export const MOCK_CUSTOMER_FINANCIALS: Financial[] = [
  {
    id: 1,
    Date: "01/06/2026",
    DocumentNumber: 100521,
    Type: "RECEIPT",
    Description: "Advance payment for refrigerated trailer work order",
    SumUp: 18500,
    FinancialStatus: "PAID",
    Download: "https://example.com/documents/100521.pdf",
  },
  {
    id: 2,
    Date: "12/06/2026",
    DocumentNumber: 100522,
    Type: "CHECK",
    Description: "Balance payment for heavy tipper body",
    SumUp: 9200,
    FinancialStatus: "SETTLED",
    Download: "https://example.com/documents/100522.pdf",
  },
  {
    id: 3,
    Date: "28/06/2026",
    DocumentNumber: 100523,
    Type: "RECEIPT",
    Description: "Closed box repair - final invoice",
    SumUp: 4300,
    FinancialStatus: "OVERDUE",
    Download: "https://example.com/documents/100523.pdf",
  },
];

export const MOCK_CUSTOMER_DOCUMENTS: CustomerDocument[] = [
  {
    id: 1,
    documentName: "Vehicle inspection report.pdf",
    connectedVehicle: "WO-5501",
    uploadedBy: "Tali Burgsen",
    date: "01/06/2026",
  },
  {
    id: 2,
    documentName: "Delivery note.pdf",
    connectedVehicle: "WO-5502",
    uploadedBy: "Dan Cohen",
    date: "12/06/2026",
  },
  {
    id: 3,
    documentName: "Warranty certificate.pdf",
    connectedVehicle: "WO-5503",
    uploadedBy: "Tali Burgsen",
    date: "28/06/2026",
  },
];

export const MOCK_CUSTOMER_TIMELINE: CustomerActivity[] = [
  {
    id: 1,
    type: "WORK_ORDER",
    title: "Work Order #1042 Completed",
    description:
      "Refrigerated body assembly completed on the FMX chassis, sub-assembly mounted, and the unit released to quality control for final inspection.",
    date: "14/05/2026 18:30",
  },
  {
    id: 2,
    type: "WORK_ORDER",
    title: "New Work Order Created (#1042)",
    description:
      "Work order opened for the FMX chassis; parts and manufacturing stages scheduled on the production floor.",
    date: "11/05/2026 09:15",
  },
  {
    id: 3,
    type: "FINANCIAL",
    title: "Price Quote Approved",
    description:
      "Price quote Q-2026-304# for \u20aa19,850.00 approved by the customer via digital signature.",
    date: "08/05/2026 14:22",
  },
  {
    id: 4,
    type: "FINANCIAL",
    title: "Price Quote Updated",
    description:
      "Update to the price quote requested by the customer, sent via WhatsApp and WiseForm, and forwarded to other departments.",
    date: "07/05/2026 11:05",
  },
  {
    id: 5,
    type: "CUSTOMER",
    title: "Customer Account Created",
    description:
      "New customer account registered with initial details; assigned to the account sales representative for \u20aa50,000.",
    date: "01/01/2026 08:00",
  },
];

export const CATEGORY_OPTIONS: CustomerSelectOption[] = [
  {
    value: "חברת ליסינג / השכרה",
    labelKey: "CUSTOMERS.DATA.CUSTOMER_1.CATEGORY",
  },
  {
    value: "צי רכב חברה / לקוח מוסדי",
    labelKey: "CUSTOMERS.DATA.CUSTOMER_2.CATEGORY",
  },
  {
    value: "חברת הובלה / לוגיסטיקה",
    labelKey: "CUSTOMERS.DATA.CUSTOMER_3.CATEGORY",
  },
  {
    value: "מוסך / בונה מרכבים",
    labelKey: "CUSTOMERS.DATA.CUSTOMER_4.CATEGORY",
  },
  {
    value: "לקוח פרטי / עצמאי",
    labelKey: "CUSTOMERS.DATA.CUSTOMER_5.CATEGORY",
  },
];

export const ADD_CUSTOMER_FIELDS: fieldConfig[] = [
  {
    key: "contactName",
    label: "CONTACT_NAME",
    type: "text",
    placeholder: "ENTER_CONTACT_NAME",
  },
  { key: "role", label: "ROLE", type: "text", placeholder: "ENTER_ROLE" },
  {
    key: "phoneNo",
    label: "CONTACT_PHONE",
    type: "text",
    placeholder: "PHONE_MASK",
  },
  {
    key: "email",
    label: "CONTACT_EMAIL",
    type: "text",
    placeholder: "ENTER_CONTACT_EMAIL",
  },
];

// Fields for CustomerForm itself, not the contact-person sub-form above
export const CUSTOMER_FORM_FIELDS: fieldConfig[] = [
  { key: "customerName", label: "CUSTOMER_NAME", type: "text" },
  {
    key: "category",
    label: "CATEGORY",
    type: "select",
    options: CATEGORY_OPTIONS,
  },
  { key: "contactPerson", label: "CONTACT_PERSON", type: "text" },
  {
    key: "contactPhone",
    label: "CONTACT_PHONE",
    type: "text",
    placeholder: "PHONE_MASK",
  },
  { key: "contactEmail", label: "CONTACT_EMAIL", type: "text" },
];

export const REQUIRED_CUSTOMER_FIELDS: Array<keyof CustomerForm> = [
  "customerName",
  "category",
  "contactPerson",
  "contactPhone",
  "contactEmail",
];


export const REQUIRED_CONTACT_FIELDS: Array<keyof contactForm> = [
  "contactName",
];
